/**
 * BackIcon/index.js
 * desc: navigation back arrow
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const BackIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="back icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.back.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16V7z"/></svg>
    </IconButton>
);


export default BackIcon;
